import React from 'react';
import { components } from 'react-select-4';
import Avatar from '~/components/shared/Avatar';

const Option = ({ children, data, ...props }) => {
  const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
  const newProps = { ...props, innerProps: rest };

  return (
    <components.Option {...newProps} className="text-break word-break">
      {data.user?.avatar_url ? (
        <>
          <Avatar
            name={data.user?.name}
            avatar={data.user?.avatar_url}
            sizeType="tiny"
            showTooltip={false}
          />
          {' '}
          {children}
        </>
      ) : (
        children
      )}
    </components.Option>
  );
};

export default Option;
